(function () {
    'use strict';

    var module = angular.module("imApp");

    module.factory("excelImportService", ['$q', '$ihttp', function ($q, $ihttp) {
        var service = {
            loaded: false,
            genericFunction: function (method_nr, parms, config) {
                var deferred = $q.defer();

                var parms_genericFunction = {
                    method: method_nr,
                    parameters: parms,
                    config: config || {}
                };

                $ihttp.post(parms_genericFunction).then(function (data) {
                    service.loaded = true;
                    deferred.resolve(data);
                });

                return deferred.promise;
            },
            getSetting: function (parms, config) {
                return $ihttp.post({
                    method: 881,
                    parameters: parms || {},
                    config: config || {}
                });
            },
            getImportProcedure: function (parms, config) {
                return $ihttp.post({
                    method: 878,
                    parameters: parms || {},
                    config: config || {}
                });
            },
            listExportProcedures: function (parms, config) {
                return $ihttp.post({
                    method: 891,
                    parameters: parms || {},
                    config: config || {}
                });
            },
        };

        return service;
    }]);
})();
